module.exports = __webpack_public_path__ + "img/emoji-sunglasses.a9f667cd.svg";